import { AppThunk } from 'src/store/store';
import { setPaymentCheckFailed, setPaymentSuccessInfo } from './paymentSlice';
import api from 'src/api';

// Thunks - these are asynchronous functions that interact with reducers in predictable ways
// All api interactions should be performed via a "thunk" so that api request state can
// be updated in the Redux store rather than at the component level

// Thunks - these are asynchronous functions that interact with reducers in predictable ways
// All api interactions should be performed via a "thunk" so that api request state can
// be updated in the Redux store rather than at the component level
type CompletionCallbackCallback = (param?: boolean) => void;

type CompletionCallback = (
  params?: unknown
) => CompletionCallbackCallback | undefined;

export const checkTaxPaymentAsync = (
  paymentID: string,
  completionCallback: CompletionCallbackCallback = () => undefined
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    try {
      const data = await api.checkTaxPayment(getState(), paymentID);
      dispatch(setPaymentSuccessInfo(data));
    } catch (error) {
      dispatch(setPaymentCheckFailed(true));
    } finally {
      completionCallback();
    }
  };
};

export const checkApplicationPaymentAsync = (
  paymentID: string,
  completionCallback: CompletionCallbackCallback = () => undefined
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    try {
      const data = await api.checkLicensePayment(getState(), paymentID);
      dispatch(setPaymentSuccessInfo(data));
    } catch (error) {
      dispatch(setPaymentCheckFailed(true));
    } finally {
      completionCallback();
    }
  };
};

export const payNothing = (
  emailAddress: string,
  onCompletionCallback: CompletionCallback
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    let outcome = {
      success: false,
      id: '',
      paymentId: '',
      paymentConfirmation: '',
    };
    try {
      const { paymentID, signatoryName } = getState()?.payment;
      const { paymentId } = await api.payNothing(
        getState(),
        paymentID,
        signatoryName,
        emailAddress
      );
      if (paymentId) {
        const data = await api.checkLicensePayment(getState(), paymentId);
        const { id, paymentConfirmation } = data;
        dispatch(setPaymentSuccessInfo(data));
        if (id !== undefined && paymentConfirmation !== undefined) {
          outcome.success = true;
          outcome.paymentId = paymentId;
          outcome.id = id;
          outcome.paymentConfirmation = paymentConfirmation;
        }
      }
      onCompletionCallback(outcome);
    } catch (error) {
      onCompletionCallback(outcome);
    }
  };
};

export const payNothingTax = (
  emailAddress: string,
  onCompletionCallback: CompletionCallback
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    try {
      const { paymentID, signatoryName } = getState()?.payment;
      const { paymentId } = await api.payNothingGeneric(
        getState(),
        paymentID,
        signatoryName,
        emailAddress
      );
      if (paymentId) {
        dispatch(
          checkTaxPaymentAsync(paymentID as string, onCompletionCallback(true))
        );
      } else {
        onCompletionCallback(false);
      }
    } catch (error) {
      onCompletionCallback(false);
    }
  };
};

export const payNothingRenewal = (
  emailAddress: string,
  onCompletionCallback: CompletionCallback
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    try {
      const { paymentID, signatoryName } = getState()?.payment;
      const { paymentId } = await api.payNothingGeneric(
        getState(),
        paymentID,
        signatoryName,
        emailAddress
      );
      if (paymentId) {
        dispatch(
          checkApplicationPaymentAsync(
            paymentID as string,
            onCompletionCallback(true)
          )
        );
      } else {
        onCompletionCallback(false);
      }
    } catch (error) {
      onCompletionCallback(false);
    }
  };
};

export const payCheck = (
  completionCallback: CompletionCallback = () => undefined
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    const { paymentID, signatoryName } = getState()?.payment;
    const email = getState().auth.userDetails?.email;

    try {
      const data = await api.payByCheck(paymentID, signatoryName, email);
      dispatch(setPaymentSuccessInfo(data));
    } catch (error) {
      dispatch(setPaymentCheckFailed(true));
    } finally {
      completionCallback();
    }
  };
};
